export default {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_USERS(state, payload) {
    state.users.list = payload
      .map((option) => ({
        value: option.usuarioId.toString(),
        label: option.usuarioNombre,
        extra: {
          run: option.usuarioRun,
          email: option.usuarioEmail,
          position: option.usuarioCargo,
          entityId: option.entidadId,
          entityName: option.entidadNombre,
          organismId: option.organismoId,
          organismName: option.organismoNombre
        }
      }));
  },
  SET_LIST(state, { target, value }) {
    let id;
    let label;
    switch (target) {
      case 'documentType':
        id = 'tipoId';
        label = 'nombre';
        break;
      case 'entity':
        id = 'entidadId';
        label = 'entidadNombre';
        break;
      default:
        break;
    }
    state[target] = value.map((element) => ({
      value: element[id].toString(),
      label: element[label]
    }));
  }
};
